module.exports = __webpack_public_path__ + "media/images/single-use-cup-bg-9d8f804a9c779299986e91489a24cd3b.png";